import {
  FactoryTypes,
  FieldID,
  WizardButtonType,
  WizardStepType,
} from "../../../models";

const getSamsungSetupSteps = () => ([
  {
    type: FactoryTypes.NUMBERED_STEP,
    fieldMapping: {
      text: FieldID.guideContainer.steps.samsungScanQRCode.text,
    }
  },
  {
    type: FactoryTypes.IMAGE_CAROUSEL,
    fieldMapping: {
      images: FieldID.guideContainer.steps.samsungScanQRCode.images
    }
  },
]);

export const eSIMWizardActivationContent = () => ({
  content: [
    {
      type: FactoryTypes.WIZARD,
      fieldMapping: {
        steps: [
          {
            introHeaderFieldMapping: {
              title: FieldID.guideContainer.activationForm.userInputTitle,
              subtext: FieldID.guideContainer.activationForm.userInputSubtitle,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.STEP,
              id: "ActivationUserInput",
            },
            primaryButtonFieldMapping: {
              buttonType: WizardButtonType.CONTINUE,
              variant:
                FieldID.guideContainer.activationForm
                  .userInputPrimaryButtonVariant,
            },
            content: [
              {
                type: FactoryTypes.ACTIVATION_FORM,
                fieldMapping: FieldID.guideContainer.activationForm,
              },
            ],
          },
          {
            introHeaderFieldMapping: {
              title: FieldID.guideContainer.activationForm.activateFailureTitle,
              subtext: FieldID.guideContainer.activationForm.activateFailureSubtitle,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.HIDDEN_STEP,
              id: "ActivationFailure",
              showWizardButtons: false,
              titleImage:
                FieldID.guideContainer.activationForm.activateFailureImage,
            },
            content: [
              {
                type: FactoryTypes.WIZARD_BUTTON,
                fieldMapping: {
                  buttonType: WizardButtonType.OPEN_CHAT,
                },
              },
              {
                type: FactoryTypes.WIZARD_BUTTON,
                fieldMapping: {
                  buttonType: WizardButtonType.CALLBACK,
                  text: FieldID.guideContainer.activationForm
                    .activationTryAgainButtonText,
                  variant: "flat",
                  callback: "ActivationUserInput",
                },
              },
            ],
          },
          {
            introHeaderFieldMapping: {
              title: FieldID.guideContainer.activationForm.activateFailureTitle,
              subtext:
                FieldID.guideContainer.activationForm.activateFailureSubtitle,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.HIDDEN_STEP,
              id: "PhysicalSIMActivationFailure",

              titleImage:
                FieldID.guideContainer.activationForm.activateFailureImage,
            },
            primaryButtonFieldMapping: {
              buttonType: WizardButtonType.OPEN_CHAT,
            },
            secondaryButtonFieldMapping: {
              buttonType: WizardButtonType.CALLBACK,
              text: FieldID.guideContainer.activationForm
                .activationTryAgainButtonText,
              variant: "flat",
              callback:
                FieldID.guideContainer.activationForm
                  .activationPhysicalSIMTryAgainCallback,
            },
          },
          {
            introHeaderFieldMapping: {
              title:
                FieldID.guideContainer.activationForm.verifyDeviceFailureTitle,
              subtext:
                FieldID.guideContainer.activationForm.activateFailureSubtitle,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.HIDDEN_STEP,
              id: "VerifyDeviceFailure",

              titleImage:
                FieldID.guideContainer.activationForm.activateFailureImage,
            },
            primaryButtonFieldMapping: {
              buttonType: WizardButtonType.OPEN_CHAT,
            },
            secondaryButtonFieldMapping: {
              buttonType: WizardButtonType.CALLBACK,
              text: FieldID.guideContainer.activationForm
                .activationTryAgainButtonText,
              variant: "flat",
              callback:
                FieldID.guideContainer.activationForm
                  .activationTryAgainCallback,
            },
          },
          {
            introHeaderFieldMapping: {
              title: FieldID.guideContainer.activationForm.activateSuccessTitle,
              subtext:
                FieldID.guideContainer.activationForm.activateSuccessSubtitle,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.STEP,
              id: "ActivationSuccess",
            },
            content: [
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  image:
                    FieldID.guideContainer.activationForm.activateSuccessImage,
                  smallMarginImage: true,
                },
              },
            ],
          },
          {
            introHeaderFieldMapping: {
              title: FieldID.guideContainer.activationForm.installPlanTitle,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.GUIDE_STEP,
              id: "ActivationInstallPlan",
            },
            content: [
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.activationForm
                    .installPlanNotificationStep.text,
                },
              },
              {
                type: FactoryTypes.DROPDOWN_STEP,
                fieldMapping: {
                  label:
                    FieldID.guideContainer.activationForm
                      .installPlanNotificationSubstep.label,
                  text: FieldID.guideContainer.activationForm
                    .installPlanNotificationSubstep.text,
                  image:
                    FieldID.guideContainer.activationForm
                      .installPlanNotificationSubstep.image,
                },
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.activationForm.pressContinueStep
                    .text,
                },
              },
              {
                type: FactoryTypes.WIZARD_STEP_LINK,
                fieldMapping: {
                  text: FieldID.guideContainer.activationForm
                    .pressContinueSubstep.text,
                  callback:
                    FieldID.guideContainer.activationForm.pressContinueSubstep
                      .linkCallback,
                  isSubstep: true,
                },
              },
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  image:
                    FieldID.guideContainer.activationForm.pressContinueSubstep
                      .image,
                },
              },
              {
                type: FactoryTypes.EXPERT_HELP,
                fieldMapping: {
                  buttonText:
                    FieldID.guideContainer.expertHelpContent.buttonText,
                  title: FieldID.guideContainer.expertHelpContent.title,
                  subtext:
                    FieldID.guideContainer.expertHelpContent.subtext,
                  icon: FieldID.guideContainer.expertHelpContent.icon,
                  supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
                  secondaryButtonText:
                    FieldID.guideContainer.expertHelpContent.secondaryButtonText,
                },
              },
            ],
          },
          {
            introHeaderFieldMapping: {
              title: FieldID.guideContainer.activationForm.transferESIMTitle,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.HIDDEN_GUIDE_STEP,
              id: "ActivationTransferESIM",
            },
            content: [
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.activationForm
                    .howToTransferESIMText,
                },
              },
              {
                type: FactoryTypes.SUB_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.activationForm
                    .howToTransferESIMSubsteps,
                  image:
                    FieldID.guideContainer.activationForm
                      .howToTransferESIMImage,
                },
              },
              {
                type: FactoryTypes.EXPERT_HELP,
                fieldMapping: {
                  buttonText:
                    FieldID.guideContainer.expertHelpContent.buttonText,
                  title: FieldID.guideContainer.expertHelpContent.title,
                  subtext:
                    FieldID.guideContainer.expertHelpContent.subtext,
                  icon: FieldID.guideContainer.expertHelpContent.icon,
                  supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
                  secondaryButtonText:
                    FieldID.guideContainer.expertHelpContent.secondaryButtonText,
                },
              },
            ],
          },
          {
            introHeaderFieldMapping: {
              title: FieldID.guideContainer.activationForm.signIntoYourGoogleAccountFlowTitle,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.HIDDEN_GUIDE_STEP,
              id: "ActivationSignIntoGoogleAccount",
            },
            primaryButtonFieldMapping: {
              buttonType: WizardButtonType.CONTINUE,
              isFinalStep: true
            },
            content: [
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.enterYourEmailOrPhone.text,
                },
              },
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.enterYourEmailOrPhone.substep,
                  image: FieldID.guideContainer.steps.enterYourEmailOrPhone.image,
                },
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.selectUser.text,
                  image: FieldID.guideContainer.steps.selectUser.image,
                },
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.chooseInfoToCopy.text,
                  image: FieldID.guideContainer.steps.chooseInfoToCopy.image,
                },
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.selectGoogleServices.text,
                  image: FieldID.guideContainer.steps.selectGoogleServices.image,
                },
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.protectYourPhone.text,
                },
              },
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.protectYourPhone.substep,
                  image: FieldID.guideContainer.steps.protectYourPhone.image,
                },
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.accessAssistant.text,
                  image: FieldID.guideContainer.steps.accessAssistant.image,
                }
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.followInstructionForAssistant.text,
                  image: FieldID.guideContainer.steps.followInstructionForAssistant.image,
                }
              },
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.followInstructionWait.text,
                  image: FieldID.guideContainer.steps.followInstructionWait.image,
                },
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.addMoreCloudStorage.text,
                  image: FieldID.guideContainer.steps.addMoreCloudStorage.image,
                }
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.attDiagnosticInfo.text,
                  image: FieldID.guideContainer.steps.attDiagnosticInfo.image,
                }
              },
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.rememberItMightTakeMinutes.text,
                  image: FieldID.guideContainer.steps.rememberItMightTakeMinutes.image,
                }
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.signInToSamsung.text,
                }
              },
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.signInToSamsung.substep,
                }
              },
              {
                type: FactoryTypes.IMAGE_CAROUSEL,
                fieldMapping: {
                  images: FieldID.guideContainer.steps.signInToSamsung.images,
                }
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.samsungServices.text,
                  image: FieldID.guideContainer.steps.samsungServices.image,
                }
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.preferredDisplayMode.text,
                  image: FieldID.guideContainer.steps.preferredDisplayMode.image,
                }
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.samsungTips.text,
                  image: FieldID.guideContainer.steps.samsungTips.image,
                }
              },
              {
                type: FactoryTypes.NUMBERED_STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.finishSignIn.text,
                  image: FieldID.guideContainer.steps.finishSignIn.image,
                }
              },
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  text: FieldID.guideContainer.steps.tryMakingCall.text,
                  image: FieldID.guideContainer.steps.tryMakingCall.image,
                }
              },
              {
                type: FactoryTypes.EXPERT_HELP,
                fieldMapping: {
                  buttonText:
                    FieldID.guideContainer.expertHelpContent.buttonText,
                  title: FieldID.guideContainer.expertHelpContent.title,
                  subtext:
                    FieldID.guideContainer.expertHelpContent.subtext,
                  icon: FieldID.guideContainer.expertHelpContent.icon,
                  supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
                  secondaryButtonText:
                    FieldID.guideContainer.expertHelpContent.secondaryButtonText,
                },
              },
              {
                type: FactoryTypes.SURVEY_STEP,
              },
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  title: FieldID.guideContainer.steps.samsungNextStepsHeader.text,
                  text: FieldID.guideContainer.steps.samsungMakeATestCallSubheader.text,
                },
              },
            ],
          },
          {
            introHeaderFieldMapping: {
              title: FieldID.guideContainer.activationForm.pSIMTitle,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.HIDDEN_GUIDE_STEP,
              id: "PhysicalSimGuide",
              showWizardButtons: false,
            },
            primaryButtonFieldMapping: {
              buttonType: WizardButtonType.CONTINUE,
            },
            content: [
              {
                type: FactoryTypes.GUIDE_INTRO,
                fieldMapping: {
                  text: FieldID.guideContainer.introduction.text,
                },
              },
              {
                type: FactoryTypes.POPUP,
                fieldMapping: {
                  buttonText:
                    FieldID.guideContainer.simCardExplanation.questionText,
                  popupTitleText:
                    FieldID.guideContainer.simCardExplanation.questionText,
                  popupDescriptionText:
                    FieldID.guideContainer.simCardExplanation.descriptionText,
                  popupImageDescriptionText:
                    FieldID.guideContainer.simCardExplanation.imageDescription,
                  popupImage: FieldID.guideContainer.simCardExplanation.image,
                },
              },
              {
                type: FactoryTypes.DECISION_STEP,
                fieldMapping: {
                  questionText:
                    FieldID.guideContainer.decisionStep.decisionOldSimCard,
                  yesSteps: [
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps
                          .activateBothPhonesPoweredOff.text,
                      },
                    },
                    {
                      type: FactoryTypes.SUB_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps
                          .activateFailIfDeviceOn.text,
                      },
                    },
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps
                          .activateLocateSimTrayOldPhone.text,
                        image:
                          FieldID.guideContainer.steps.locateSimCardTrayStep
                            .image,
                      },
                    },
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping:
                        FieldID.guideContainer.steps.activateRemoveSimTray,
                    },
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps
                          .activateRepeatRemoveSimProcess.text,
                      },
                    },
                    {
                      type: FactoryTypes.TIPBOX,
                      fieldMapping: {
                        heading: FieldID.guideContainer.tipBox.simCardCautionText,
                        text: FieldID.guideContainer.tipBox.simCardCautionText,
                        icon: FieldID.guideContainer.tipBox.iconV2,
                        iconPosition: "left",
                      },
                    },
                    {
                      type: FactoryTypes.STEP,
                      fieldMapping: {
                        image:
                          FieldID.guideContainer.steps.insertNewSimCard.image,
                      },
                    },
                    {
                      type: FactoryTypes.EXPERT_HELP,
                      fieldMapping: {
                        buttonText:
                          FieldID.guideContainer.expertHelpContent.buttonText,
                        title: FieldID.guideContainer.expertHelpContent.title,
                        subtext:
                          FieldID.guideContainer.expertHelpContent.subtext,
                        icon: FieldID.guideContainer.expertHelpContent.icon,
                        supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
                        secondaryButtonText:
                          FieldID.guideContainer.expertHelpContent.secondaryButtonText,
                      },
                    },
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps
                          .activateTurnOnNewPhone.text,
                      },
                    },
                    {
                      type: FactoryTypes.ACTIVATION_FORM,
                      fieldMapping: {
                        activateOnClick: false,
                      },
                    },
                  ],
                  noSteps: [
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps.powerOffNewPhoneStep
                          .text,
                      },
                    },
                    {
                      type: FactoryTypes.SUB_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps
                          .activateFailIfDeviceOn.text,
                      },
                    },
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps.locateSimCardTrayStep
                          .text,
                        image:
                          FieldID.guideContainer.steps.locateSimCardTrayStep
                            .image,
                      },
                    },
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps.insertNewSimCard
                          .text,
                      },
                    },
                    {
                      type: FactoryTypes.TIPBOX,
                      fieldMapping: {
                        heading: FieldID.guideContainer.tipBox.simCardCautionText,
                        text: FieldID.guideContainer.tipBox.simCardCautionText,
                        icon: FieldID.guideContainer.tipBox.iconV2,
                        iconPosition: "left",
                      },
                    },
                    {
                      type: FactoryTypes.STEP,
                      fieldMapping: {
                        image:
                          FieldID.guideContainer.steps.insertNewSimCard.image,
                      },
                    },
                    {
                      type: FactoryTypes.EXPERT_HELP,
                      fieldMapping: {
                        buttonText:
                          FieldID.guideContainer.expertHelpContent.buttonText,
                        title: FieldID.guideContainer.expertHelpContent.title,
                        subtext:
                          FieldID.guideContainer.expertHelpContent.subtext,
                        icon: FieldID.guideContainer.expertHelpContent.icon,
                        supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
                        secondaryButtonText:
                          FieldID.guideContainer.expertHelpContent.secondaryButtonText,
                      },
                    },
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps.activateClickActivate
                          .text,
                      },
                    },
                    {
                      type: FactoryTypes.ACTIVATION_FORM,
                      fieldMapping: {
                        activateOnClick: true,
                      },
                    },
                  ],
                },
              },
            ],
          },
          {
            introHeaderFieldMapping: {
              title: FieldID.guideContainer.activationForm.activateSuccessTitle,
              subtext:
                FieldID.guideContainer.activationForm
                  .activateSuccessPSimSubtitle,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.HIDDEN_STEP,
              id: "PhysicalSIMActivationSuccess",
            },
            content: [
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  image:
                    FieldID.guideContainer.activationForm.activateSuccessImage,
                  smallMarginImage: true,
                },
              },
            ],
          },
          {
            introHeaderFieldMapping: {
              title: FieldID.guideContainer.activationForm.allSetTitle,
              subtext: FieldID.guideContainer.activationForm.allSetSubtitle,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.STEP,
              id: "ActivationAllSet",
            },
            primaryButtonFieldMapping: {
              buttonType: WizardButtonType.CONTINUE,
              text: FieldID.guideContainer.activationForm
                .allSetPrimaryButtonText,
              variant:
                FieldID.guideContainer.activationForm
                  .allSetPrimaryButtonVariant,
            },
            secondaryButtonFieldMapping: {
              buttonType: WizardButtonType.OPEN_CHAT,
              text: FieldID.guideContainer.activationForm
                .allSetSecondaryButtonText,
            },
            content: [
              {
                type: FactoryTypes.STEP,
                fieldMapping: {
                  image: FieldID.guideContainer.activationForm.allSetIcon,
                  smallMarginImage: true,
                },
              },
            ],
          },
          {
            introHeaderFieldMapping: {
              title: FieldID.guideContainer.activationForm.activationSamsungSetup,
            },
            wizardStepFieldMapping: {
              stepType: WizardStepType.HIDDEN_GUIDE_STEP,
              id: "ActivationSamsungSetup",
              showWizardButtons: false
            },
            content: [
              {
                type: FactoryTypes.DECISION_STEP,
                fieldMapping: {
                  questionText: FieldID.guideContainer.decisionStep.samsungSetupSteps,
                  yesSteps: [
                    {
                      type: FactoryTypes.SURVEY_STEP,
                    },
                    {
                      type: FactoryTypes.EXPERT_HELP,
                      fieldMapping: {
                        buttonText:
                          FieldID.guideContainer.expertHelpContent.buttonText,
                        title: FieldID.guideContainer.expertHelpContent.title,
                        subtext:
                          FieldID.guideContainer.expertHelpContent.subtext,
                        icon: FieldID.guideContainer.expertHelpContent.icon,
                        supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
                        secondaryButtonText:
                          FieldID.guideContainer.expertHelpContent.secondaryButtonText,
                      },
                    },
                    {
                      type: FactoryTypes.WIZARD_BUTTON,
                      fieldMapping: {
                        buttonType: WizardButtonType.CALLBACK,
                        variant: "default",
                        callback: "ActivationAllSet",
                        isFinalStep: true
                      },
                    },
                  ],
                  noSteps: [
                    {
                      type: FactoryTypes.TIPBOX,
                      fieldMapping: {
                        heading: FieldID.guideContainer.tipBox.beforeSamsungSetup,
                        text: FieldID.guideContainer.tipBox.beforeSamsungSetup,
                        icon: FieldID.guideContainer.tipBox.exclamationPointIcon,
                      }
                    },
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps.samsungLanguageSelect.text,
                        image: FieldID.guideContainer.steps.samsungLanguageSelect.image,
                      }
                    },
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps.samsungTermsAndConditions.text,
                        image: FieldID.guideContainer.steps.samsungTermsAndConditions.image,
                      }
                    },
                    {
                      type: FactoryTypes.NUMBERED_STEP,
                      fieldMapping: {
                        text: FieldID.guideContainer.steps.samsungCopySettings.text,
                        image: FieldID.guideContainer.steps.samsungCopySettings.image,
                      }
                    },
                    {
                      type: FactoryTypes.DECISION_STEP,
                      fieldMapping: {
                        questionText: FieldID.guideContainer.decisionStep.samsungShowInstructionsFor,
                        decisionOptions: [
                          {
                            display: "Samsung or Android device",
                            steps: getSamsungSetupSteps()
                          },
                          {
                            display: "Set up manually",
                            steps: [
                              {
                                type: FactoryTypes.NUMBERED_STEP,
                                fieldMapping: {
                                  text: FieldID.guideContainer.steps.samsungManualSetupConnectToWiFi.text,
                                }
                              },
                              {
                                type: FactoryTypes.IMAGE_CAROUSEL,
                                fieldMapping: {
                                  images: FieldID.guideContainer.steps.samsungManualSetupConnectToWiFi.images
                                }
                              },
                              {
                                type: FactoryTypes.NUMBERED_STEP,
                                fieldMapping: {
                                  text: FieldID.guideContainer.steps.samsungManualSetupDownloadCellularPlan.text,
                                }
                              },
                              {
                                type: FactoryTypes.IMAGE_CAROUSEL,
                                fieldMapping: {
                                  images: FieldID.guideContainer.steps.samsungManualSetupDownloadCellularPlan.images
                                }
                              },
                            ]
                          }
                        ]
                      }
                    },
                    {
                      type: FactoryTypes.EXPERT_HELP,
                      fieldMapping: {
                        buttonText:
                          FieldID.guideContainer.expertHelpContent.buttonText,
                        title: FieldID.guideContainer.expertHelpContent.title,
                        subtext:
                          FieldID.guideContainer.expertHelpContent.subtext,
                        icon: FieldID.guideContainer.expertHelpContent.icon,
                        supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
                        secondaryButtonText:
                          FieldID.guideContainer.expertHelpContent.secondaryButtonText,
                      },
                    },
                    {
                      type: FactoryTypes.SURVEY_STEP,
                    },
                    {
                      type: FactoryTypes.STEP,
                      fieldMapping: {
                        title: FieldID.guideContainer.steps.samsungNextStepsHeader.text,
                        text: FieldID.guideContainer.steps.samsungGoogleSignInSubheader.text,
                      },
                    },
                    {
                      type: FactoryTypes.WIZARD_BUTTON,
                      fieldMapping: {
                        buttonType: WizardButtonType.CALLBACK,
                        variant: "default",
                        callback: "ActivationSignIntoGoogleAccount",
                        isFinalStep: true
                      },
                    },
                  ],
                }
              },
            ]
          },
        ],
      },
    },
  ],
});